import {
  WheelContainerAnimation,
  WheelAnimation,
  WheelClickerAnimation,
} from '../SurprisePerk.styles';

interface SpinToWinAnimationProps {
  shouldAnimate: boolean;
  onAnimationEnd: () => void;
}

const SpinToWinAnimation = ({ shouldAnimate, onAnimationEnd }: SpinToWinAnimationProps) => (
  <WheelContainerAnimation
    aria-label="Spin to win"
    shouldAnimate={shouldAnimate}
    onAnimationEnd={onAnimationEnd}
  >
    <WheelClickerAnimation shouldAnimate={shouldAnimate} />
    <WheelAnimation shouldAnimate={shouldAnimate} />
  </WheelContainerAnimation>
);

export default SpinToWinAnimation;
